const RichRelevanceBaseInstrumentationController = require('./rr-base-instrumentation-controller');

class RichRelevanceItemInstrumentationController extends RichRelevanceBaseInstrumentationController {

    constructor($scope, $window, featureService, richRelevanceService) {
        super($scope, $window, featureService, richRelevanceService, { instrumentOnStateChange: false });
        this.richRelevanceService = richRelevanceService;
        this.$window = $window;
    }

    $onInit() {
        // we handle this manually since this is instantiated after
        // $stateChangeSuccess on product details page.
        this.sendInstrumentation();
    }

    sendInstrumentation() {
        this.richRelevanceService.getInformation()
            .then(() => {
                this.$window.R3_ITEM = new this.$window.r3_item(); // eslint-disable-line new-cap
                this.$window.R3_ITEM.setId(this.itemId.toString()); // This must pass a string value, as RR calls indexOf() on this internally, possibly to URL encode it.
                this.$window.R3_ITEM.setName(this.itemName);
                this.addPlacementTypesIfEnabled();
                this.$window.rr_flush_onload();
                this.$window.r3();
            });
    }
}

const richRelevanceItemInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', RichRelevanceItemInstrumentationController],
    bindings: {
        itemId: '<',
        itemName: '<',
        pageGroup: '@',
        placementIds: '<',
    },
};

module.exports = {
    RichRelevanceItemInstrumentationController,
    richRelevanceItemInstrumentationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/instrumentation/rr-item-instrumentation.component.js